import { api } from './_api-client';

export enum MarkerPresetType {
  'Alt All Beats',
  'All Beats',
  'Down Beats (Auto)',
  'Down Beats (3/4)',
  'Down Beats (4/4)',
}

/** Dropdown order: Auto, 4/4, 3/4, All, Alt All */
export const MARKER_PRESET_DISPLAY_ORDER: MarkerPresetType[] = [2, 4, 3, 1, 0];

export const sortMarkerPresets = <T extends { type: MarkerPresetType }>(presets: T[]): T[] =>
  [...presets].sort(
    (a, b) => MARKER_PRESET_DISPLAY_ORDER.indexOf(a.type) - MARKER_PRESET_DISPLAY_ORDER.indexOf(b.type)
  );

export interface MarkerPreset {
  id: MarkerPresetId;
  type: MarkerPresetType;
  value: EditorTime[];
}

export interface SetStoryAudio {
  storyId: StoryId;
  audioFileId: AudioFileId;
}

export interface GetAudioMarkersRes {
  beatMarkerPresetId: MarkerPresetId | null;
  result: MarkerId[];
}

export interface GetAudioMarkerPresetsRes {
  result: MarkerPreset[];
}

export interface PassAudioMarkersBody {
  ids: MarkerId[];
  storyId: StoryId;
}

export interface PassAudioMarkersRes {
  result: { result: MarkerId[] };
}

export interface SetAudioMarkersPresetRes {
  result: MarkerId[];
}

// S E R V I C E

export const setStoryAudio = (payload: SetStoryAudio) => {
  const { storyId, audioFileId } = payload;
  return api.post(`/AudioMarker/ChangeAudioTrack?storyId=${storyId}&audioFileId=${audioFileId}`);
};

export const getAudioMarkers = (storyId: StoryId) => {
  return api.get<GetAudioMarkersRes>(`/AudioMarker/GetAudioMarkers?storyId=${storyId}`);
};

export const getAudioMarkerPresets = (mediaFileId: FileId) => {
  return api.get<GetAudioMarkerPresetsRes>(`/AudioMarker/GetAudioMarkerPresets?mediaFileId=${mediaFileId}`);
};

export const passAudioMarkers = (body: PassAudioMarkersBody) => {
  return api.post<PassAudioMarkersRes>(`/AudioMarker/PassAudioMarkers`, body);
};

export const setAudioMarkerPreset = (storyId: StoryId, presetId: MarkerPresetId) => {
  return api.post<SetAudioMarkersPresetRes>(
    `/AudioMarker/SetAudioMarkerPreset?storyId=${storyId}&presetId=${presetId}`
  );
};
